import React from "react";

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(function TextInput(
  { className, type = "text", ...rest },
  ref
) {
  const classes = ["ui-input", className].filter(Boolean).join(" ");
  return <input ref={ref} type={type} className={classes} {...rest} />;
});

export default TextInput;
